import React from "react";

import img1 from "../img/Entities 00041&&Status Believing---Adobe Photoshop experiments with different patterns and textures over AI generated images___2025-09[[2]].jpg"

export default function Machine_3_5() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="3.5 · INCOMING TRANSMISSIONS"
        />
      </div>

      <div className="panel-container-right">
        <h2>3.5 · INCOMING TRANSMISSIONS</h2>

      <p>
    The archive is not closed.
  </p>

  <p>
    Cycles expand.<br />
    Sections mutate.<br />
    New formats emerge.
  </p>

  <p>
    Nothing here is final.
  </p>

  <p>
    If the Machine releases more,<br />
    it will appear without warning.
  </p>

  <p>
    Stay attentive.
  </p>
      </div>

    </div>
  );
}
